//Get  all articles
export const GET_ALL_ARTICLES_REQ = "GET_ALL_ARTICLES_REQ";
export const GET_ALL_ARTICLES_ERR = "GET_ALL_ARTICLES_ERR";
export const GET_ALL_ARTICLES_SUCC = "GET_ALL_ARTICLES_SUCC";

//GET ARTICLE BY ARTICLE ID
export const GET_ARTICLE_BY_ARTICLE_ID_REQ ="GET_ARTICLE_BY_ARTICLE_ID_REQ";
export const GET_ARTICLE_BY_ARTICLE_ID_ERR ="GET_ARTICLE_BY_ARTICLE_ID_ERR";
export const GET_ARTICLE_BY_ARTICLE_ID_SUCC ="GET_ARTICLE_BY_ARTICLE_ID_SUCC";
